import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M9.5 12L14.5 17V7L9.5 12Z" xmlns="http://www.w3.org/2000/svg" />,
  "CaretLeft"
);
